import { Suspense } from "react";
import ProductDetailsClient from "./ProductDetailsClient";

export default function Page() {
  return (
    <Suspense fallback={<p>Loading...</p>}>
      <ProductDetailsClient />
    </Suspense>
  );
}
